module.exports = __webpack_public_path__ + "img/dxy.77af162a.png";